
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Navimumbaiairporttopunecab() {



const cardData = {
  keyword: 'Navi Mumbai Airport to Pune Cab',
  heading: 'Skyline Cabs: Navi Mumbai Airport to Pune Cab',
  headingDescription: 'Skyline Cabs offers reliable, affordable, and professional Navi Mumbai Airport to Pune Cab services for smooth intercity airport transfers. Whether you are landing at Navi Mumbai International Airport or planning advance airport pickup to Pune, we ensure punctual arrival and stress-free travel. Our fleet includes AC sedan cab like Swift Dzire and Hyundai Aura, Ertiga cab, Kia Carens, Innova Crysta, SUV cab, and Tempo Traveller for group transfers. We monitor flight schedules in real-time to adjust pickup timing in case of delays, ensuring zero waiting hassle. With transparent Navi Mumbai Airport to Pune cab fare, one-way cab options, 24x7 availability, and secure online cab booking, Skyline Cabs is the best and most reliable airport transfer service for families, corporate travelers, and business clients traveling from Navi Mumbai Airport to Pune.',

  top: 'Top Places to Visit in Pune with Skyline Cabs',

  topPlaces: [
    {
      title: "Sinhagad Fort",
      description: "Sinhagad Fort is one of the most iconic historical attractions near Pune, known for its rich Maratha history and breathtaking hilltop views. The fort is associated with the legendary Battle of Sinhagad and offers panoramic views of valleys and mountains. Visitors enjoy trekking routes and local Maharashtrian food stalls at the top. It is a perfect blend of adventure and history. Skyline Cabs ensures comfortable travel from Navi Mumbai Airport to Pune for visitors planning to explore this historic destination."
    },
    {
      title: "Aga Khan Palace",
      description: "Aga Khan Palace is a significant national monument connected to India’s freedom movement. Built in 1892, it once served as a prison for Mahatma Gandhi during the Quit India Movement. The palace features elegant architecture, wide lawns, and a museum showcasing rare photographs and artifacts. It attracts history lovers from across India. Skyline Cabs provides smooth Navi Mumbai Airport to Pune taxi service for tourists visiting this heritage site."
    },
    {
      title: "Dagdusheth Halwai Ganpati Temple",
      description: "Dagdusheth Halwai Ganpati Temple is one of the most famous and spiritually important temples in Maharashtra. The temple houses a grand idol adorned with gold ornaments and attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the center of vibrant celebrations. It is a must-visit religious destination in Pune."
    },
    {
      title: "Shaniwar Wada",
      description: "Shaniwar Wada is a historic fortification built in 1732 that once served as the seat of the Peshwas. Known for its massive gates and beautiful gardens, it reflects Maratha architectural brilliance. Evening light and sound shows enhance the visitor experience. It stands as a proud symbol of Pune’s heritage."
    },
    {
      title: "Osho Ashram",
      description: "Osho Ashram in Koregaon Park is an internationally recognized meditation center offering wellness programs and spiritual retreats. Surrounded by lush greenery, it provides peaceful and rejuvenating experiences. Visitors from across the globe come here for meditation and relaxation."
    },
    {
      title: "Pune-Okayama Friendship Garden",
      description: "Inspired by Japanese landscaping, this garden features flowing streams, wooden bridges, and manicured lawns. It is one of the largest Japanese gardens outside Japan and offers calm surroundings for relaxation."
    },
    {
      title: "Raja Dinkar Kelkar Museum",
      description: "This museum houses thousands of artifacts including musical instruments, sculptures, and decorative arts from across India. It is a cultural treasure that showcases India’s artistic heritage."
    },
    {
      title: "Pataleshwar Cave Temple",
      description: "Pataleshwar Cave Temple is an 8th-century rock-cut temple dedicated to Lord Shiva. Carved from a single rock, it showcases ancient architecture and spiritual serenity."
    },
    {
      title: "Khadakwasla Dam",
      description: "Khadakwasla Dam is a scenic picnic spot offering peaceful water views and sunset photography opportunities. It is a popular weekend getaway for families."
    },
    {
      title: "Mulshi Lake",
      description: "Mulshi Lake is surrounded by hills and greenery, offering a refreshing escape from city life. It is ideal for nature drives and peaceful outings near Pune."
    }
  ],

  services: [
    {
      name: "One Way Navi Mumbai Airport to Pune Cab",
      description: "Book one way cab Navi Mumbai Airport to Pune with Skyline Cabs for affordable, comfortable, and reliable intercity travel. Our AC sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller options ensure smooth Mumbai-Pune Expressway rides with transparent pricing, toll included fares, and professional chauffeurs for safe long-distance transfers."
    },
    {
      name: "Airport Pickup Cab Navi Mumbai to Pune",
      description: "Our airport pickup cab Navi Mumbai to Pune includes real-time flight tracking, punctual terminal arrival, luggage assistance, and direct transfer to your Pune destination. We ensure smooth, stress-free highway travel with experienced drivers and sanitized vehicles."
    },
    {
      name: "Innova & SUV Cab Navi Mumbai Airport to Pune",
      description: "Choose Innova Crysta or SUV cab Navi Mumbai Airport to Pune for premium comfort and spacious travel. Ideal for families and corporate travelers needing extra luggage space and luxury seating for long-distance airport transfers."
    },
    {
      name: "Sedan & Ertiga Cab Navi Mumbai Airport to Pune",
      description: "Affordable sedan cab Navi Mumbai Airport to Pune including Swift Dzire, Hyundai Aura, and Ertiga options for budget-friendly yet safe airport transfer service with transparent fare structure."
    }
  ],

  tableData: [
    ["Navi Mumbai Airport to Pune Cab", "Mumbai Airport to Pune Cab"],
    ["Navi Mumbai Airport to Pune Taxi", "Mumbai to Pune Taxi from Airport"],
    ["One Way Cab Navi Mumbai Airport to Pune", "Mumbai Pune Cab One Way"],
    ["Airport Pickup Cab Navi Mumbai to Pune", "Cab from Navi Mumbai Airport to Pune"],
    ["Online Cab Booking Navi Mumbai Airport to Pune", "Book Cab from Navi Mumbai Airport to Pune"],
    ["Cheapest Cab Navi Mumbai Airport to Pune", "Best Cab Navi Mumbai Airport to Pune"],
    ["Reliable Taxi Navi Mumbai Airport to Pune", "Mumbai Airport to Pune Taxi Fare"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Guaranteed On-Time Airport Pickup",
      WhyChoosedescription: "We monitor flight schedules in real-time and ensure timely pickup from Navi Mumbai Airport with zero waiting stress and direct expressway travel toward Pune."
    },
    {
      WhyChooseheading: "Experienced Highway Drivers",
      WhyChoosedescription: "Our professional chauffeurs are experienced in Mumbai-Pune Expressway driving, ensuring safe, smooth, and comfortable long-distance travel."
    },
    {
      WhyChooseheading: "Transparent Fare Structure",
      WhyChoosedescription: "We provide clear and upfront Navi Mumbai Airport to Pune cab fare including tolls and driver charges without hidden fees."
    },
    {
      WhyChooseheading: "Wide Vehicle Options",
      WhyChoosedescription: "Choose from sedan, Ertiga, Innova Crysta, SUV, and Tempo Traveller based on your comfort and luggage requirements."
    },
    {
      WhyChooseheading: "24x7 Availability",
      WhyChoosedescription: "Our Navi Mumbai Airport to Pune taxi service operates round-the-clock including early morning and late-night transfers."
    },
    {
      WhyChooseheading: "Safe & Sanitized Vehicles",
      WhyChoosedescription: "All vehicles are regularly cleaned and sanitized to ensure safe and hygienic airport transfers."
    },
    {
      WhyChooseheading: "Secure Online Booking",
      WhyChoosedescription: "Book your cab from Navi Mumbai Airport to Pune through our secure platform with instant confirmation."
    },
    {
      WhyChooseheading: "Comfortable Expressway Travel",
      WhyChoosedescription: "Enjoy smooth and relaxed travel via Mumbai-Pune Expressway with AC vehicles and professional service."
    }
  ]
}



const faqData = [
    {
        id: 1,
        question: 'How do I book a Navi Mumbai Airport to Pune Cab with Skyline Cabs?',
        answer:
            'Booking your Navi Mumbai Airport to Pune Cab is quick and easy. Visit our website, enter your pickup location as Navi Mumbai Airport and drop location as Pune, select your preferred car, and confirm your ride instantly.',
    },
    {
        id: 2,
        question: 'Is Skyline Cabs available 24/7 for Navi Mumbai Airport to Pune Cab service?',
        answer:
            'Yes, we operate 24/7 Navi Mumbai Airport to Pune Cab services, including late-night arrivals and early-morning departures for complete travel convenience.',
    },
    {
        id: 3,
        question: 'Can I pre-book my Navi Mumbai Airport to Pune Cab in advance?',
        answer:
            'Absolutely! You can schedule your airport-to-Pune cab in advance to ensure guaranteed availability and timely pickup, especially during weekends or peak travel seasons.',
    },
    {
        id: 4,
        question: 'What car options are available for Navi Mumbai Airport to Pune Cab?',
        answer:
            'We offer a wide fleet including Sedans, SUVs, Ertiga, Innova Crysta, and premium vehicles — suitable for solo travelers, families, and corporate clients traveling to Pune.',
    },
    {
        id: 5,
        question: 'Is the fare for Navi Mumbai Airport to Pune Cab fixed?',
        answer:
            'Yes, Skyline Cabs provides transparent and fixed pricing. The fare includes tolls, taxes, and driver charges with no hidden costs.',
    },
    {
        id: 6,
        question: 'Do you provide flight tracking for airport pickups?',
        answer:
            'Yes, we track your flight status to adjust pickup timing in case of delays, ensuring a smooth and stress-free airport pickup experience.',
    },
    {
        id: 7,
        question: 'Are one-way Navi Mumbai Airport to Pune Cab services available?',
        answer:
            'Yes, we offer affordable one-way cab services from Navi Mumbai Airport to Pune, allowing you to pay only for the distance traveled.',
    },
    {
        id: 8,
        question: 'Is online payment available for booking?',
        answer:
            'Yes, you can make secure online payments using UPI, credit/debit cards, or net banking. Instant confirmation is provided after successful payment.',
    },
    {
        id: 9,
        question: 'How long does it take to travel from Navi Mumbai Airport to Pune by cab?',
        answer:
            'The journey usually takes around 2.5 to 3.5 hours depending on traffic conditions, ensuring a comfortable and direct ride to Pune.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Navi Mumbai Airport to Pune Cab?',
        answer:
            'Skyline Cabs offers punctual service, professional drivers, clean and sanitized vehicles, competitive fares, and 24x7 customer support — making your Navi Mumbai Airport to Pune journey smooth and dependable.',
    },
];

const someReviews = [
    {
        name: "Mr. Karan Joshi",
        rating: 5,
        review: "Booked a Navi Mumbai Airport to Pune Cab with Skyline Cabs after landing late at night. The driver was waiting on time and the ride to Pune was smooth and comfortable. Excellent service!"
    },
    {
        name: "Mrs. Neha Kapoor",
        rating: 4,
        review: "Very reliable cab service from Navi Mumbai Airport to Pune. Transparent pricing, clean vehicle, and courteous driver. I will definitely book Skyline Cabs again."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai Airport to Pune Cab",
  "image": "https://skylinecabs.com/assets/images/navi-mumbai-airport-to-pune-cab.jpg",
  "description": "Book Navi Mumbai Airport to Pune Cab with Skyline Cabs for safe, comfortable and affordable one way or round trip travel. Professional drivers, clean sedans, SUVs and Innova available for airport pickup to Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2499",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/navi-mumbai-airport-to-pune-cab"
  }
};



    return (
        <div>


<Helmet>
  <title>Navi Mumbai Airport to Pune Cab | One Way Taxi | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Navi Mumbai Airport to Pune Cab with Skyline Cabs for reliable one way and round trip taxi service. Affordable fares, professional drivers and comfortable cars available 24x7." 
  />
  <meta 
    name="keywords" 
    content="mumbai airport to pune cab, mumbai to pune cab service, mumbai airport to pune taxi fare, mumbai pune cab one way, mumbai to pune cab from airport, mumbai airport to pune cab fare, mumbai international airport to pune cab, mumbai to pune taxi from airport, navi mumbai airport to pune cab, navi mumbai airport to pune taxi, navi mumbai airport to pune cab service, navi mumbai airport to pune taxi service, cab from navi mumbai airport to pune, book cab from navi mumbai airport to pune, online cab booking navi mumbai airport to pune, best cab navi mumbai airport to pune, cheapest cab navi mumbai airport to pune, reliable taxi navi mumbai airport to pune, airport pickup cab navi mumbai to pune, one way cab navi mumbai airport to pune, round trip cab navi mumbai airport to pune, Skyline Cabs Navi Mumbai Airport to Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/116.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Navimumbaiairporttopunecab;